import app from './app';
import authentication from './authentication';

import tmDashboard from './tm/dashboard';
import tmInvestigation from './tm/investigation';
import tmInvestigationDetail from './tm/investigationDetail';
import tmOperation from './tm/operation';
import settings from './settings';

import utils from './tm/utils';

import nsDashboard from './ns/dashboard';
import nsAnalystThroughput from './ns/analystThroughput';
import nsSupervisorDashboard from './ns/supervisorDashboard';
import nsInvestigation from './ns/investigation';
import nsInvestigationDetail from './ns/investigationDetail';
import nsMatchingConfig from './ns/matchingConfig';
import nsRunInstanceConfig from './ns/runInstance';
import nsTickets from './ns/tickets';
import nsCommon from './ns/common';
import nsRiskIndicators from './ns/riskIndicators';
import nsOnDemandScreening from './ns/onDemandScreening';

import crsRiskDetailReducer from './crs/crsRiskDetailReducer';
import crsListView from './crs/crsListView';
import crsDashboard from './crs/crsDashboard';
import crsRiskIndicator from './crs/crsRiskIndicator';

import trmDashboard from './trm/trmDashboard';
import scenarioRiskIndicators from './trm/riskIndicators';
import trmConfigurations from './trm/systemConfiguration';
import typologyAnalyzer from './trm/typologyAnalyzer';

import cmAlertList from './cm/alertList';
import cmAlertDetails from './cm/alertDetails';
import cmAutomation from './cm/automation';
import cmAutomationCustomers from './cm/automationCustomers';
import cmCaseDetails from './cm/caseDetails';
import cmCaseList from './cm/caseList';
import cmCaseCreation from './cm/caseCreation';
import cmCustomers from './cm/customers';
import cmDepartments from './cm/departments';
import cmUserList from './cm/users';
import cmCaseAction from './cm/caseAction';
import cmAlertNote from './cm/alertNote';
import cmInvestigatorsWorkload from './cm/investigatorsWorkload';
import cmAlertAction from './cm/alertAction';
import cmConvertAlertsToCase from './cm/convertAlertsToCase';
import cmMergeAlertsToCase from './cm/mergeAlertsToCase';
import cmDashboard from './cm/dashboard';
import cmAssignCaseToUser from './cm/assignCaseToUser';
import cmMakerCheckerList from './cm/makerCheckerList';
import cmCaseHistory from './cm/caseHistory';
import cmContext from './cm/context';
import cmWorkFlowStatus from './cm/workFlowStatus';
import cmWhiteList from './cm/whiteList';
import cmWhitelistDetails from './cm/whitelistDetails';
import cmAlertRetryHistoryList from './cm/alertRetryHistoryList';
import cmCaseReport from './cm/caseReport';
import cmCaseReportHistory from './cm/caseReportHistory';

// AMLS Common reducers
import amlsCommon from './common';
import amlsTMCommon from './tmCommon';

const reducers = {
  app,
  authentication,

  tmDashboard,
  tmOperation,
  tmInvestigation,
  tmInvestigationDetail,
  settings,

  // nsRiskView,
  nsAnalystThroughput,
  nsSupervisorDashboard,
  nsInvestigation,
  nsInvestigationDetail,

  //ns:iad
  nsMatchingConfig,
  nsRunInstanceConfig,
  nsTickets,
  nsCommon,
  nsRiskIndicators,
  nsOnDemandScreening,

  // NS Dashboard
  nsDashboard,

  //utils
  utils,

  // CRS Module
  crsDashboard,
  crsRiskDetailReducer,
  crsListView,
  crsRiskIndicator,

  //trm
  trmDashboard,
  scenarioRiskIndicators,
  trmConfigurations,
  typologyAnalyzer,

  //cm
  cmAlertList,
  cmAlertDetails,
  cmAutomation,
  cmAutomationCustomers,
  cmCaseDetails,
  cmCaseList,
  cmCaseCreation,
  cmCustomers,
  cmDepartments,
  cmUserList,
  cmCaseAction,
  cmAlertNote,
  cmInvestigatorsWorkload,
  cmAlertAction,
  cmConvertAlertsToCase,
  cmMergeAlertsToCase,
  cmDashboard,
  cmAssignCaseToUser,
  cmMakerCheckerList,
  cmCaseHistory,
  cmContext,
  cmWorkFlowStatus,
  cmWhiteList,
  cmWhitelistDetails,
  cmAlertRetryHistoryList,
  cmCaseReport,
  cmCaseReportHistory,
  //AMLS Common
  amlsCommon,

  //AMLS TM COMMON
  amlsTMCommon
};

export default reducers;
